import { DashboardContainer } from "./DashboardContainer";
import PageLayout from "../PageLayout";
import "./index.scss";

const Dashboard = () => {
  return (
    <PageLayout>
      <div className="content-layout dashboard-wrapper" id="tableDiv">
        <div className="tabular-view">
          <DashboardContainer />
        </div>
      </div>
    </PageLayout>
  );
};
export default Dashboard;
